/// <reference path="../typings/browser.d.ts" />

export const $modalSID = '$modal';
export const $modalInstanceSID = '$modalInstance';
